import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonImg, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';


import '../../../css/layout.css';

export function AddScopeModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [scopeName, setScopeName] = useState('');
    let [scopeDescription, setScopeDescription] = useState('');
    let [scopeEstimatedPrice, setScopeEstimatedPrice] = useState('');
    let [createScopePublicPrice, setCreateScopePublicPrice] = useState(null);


    function addScope()
    {
        
        
        let formData = new FormData();
        formData.append('Tracker', '74101_add_scope');
        formData.append('user', acctID);
        formData.append('xCustomerAccountID', props.data.customerAccountID);
        formData.append('xConsultationID', props.data.consultationID)
        formData.append('xScopeName', scopeName);
        formData.append('xScopeDescription', scopeDescription);
        formData.append('xScopeEstimatedPrice', scopeEstimatedPrice);
        formData.append('xScopePublicPrice', createScopePublicPrice);
        formData.append('xExternalID', props.data.externalID);
        formData.append('xUserStatus', props.data.userStatus);
        formData.append('sessionID', sessionID);



        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false)
    }

    function handleCreateScopeEstimatePrice(event) {
        const salePrice = parseFloat(event) || 0; // convert to number, default 0
        setScopeEstimatedPrice(salePrice);
    
        const productPublicPrice = salePrice + (salePrice * 0.03);
        setCreateScopePublicPrice(productPublicPrice);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    
    //alert("IN CREATE PRODUCT")

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: 'black'}}>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <h3>ADD SCOPE</h3>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
             <IonContent className='grid_content'>

            <IonSlides pager='true'>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='6'>
                                <IonText for='searchSupplierName'>Scope Name:</IonText>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={ scopeName }  placeholder='Enter Scope Name' autocomplete='off' onIonChange={(e) => setScopeName(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='6'>
                                <IonText for='searchSupplierName'>Description:</IonText>
                            </IonCol>
                            <IonCol size='6'>
                                <IonInput className='professional-input' type='text' value={ scopeDescription }  placeholder='Enter Description' autocomplete='off' onIonChange={(e) => setScopeDescription(e.target.value)} required></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked" >Merchant Price:</IonLabel>
                                <IonInput className='professional-input'
                                value={scopeEstimatedPrice}
                                type='number' 
                                step='any'
                                placeholder="Enter Product Sale Price"
                                onIonChange={(e) => handleCreateScopeEstimatePrice(e.target.value)}
                                required
                                ></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol size='12'>
                                <IonLabel className="form-label" position="stacked" >Scope Public Price:</IonLabel>
                                <IonText className='professional-text'>{createScopePublicPrice}</IonText>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
            </IonSlides>

        </IonContent>
        <IonFooter class='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => addScope()}> Confirm Scope Creation </IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}